// Imports
import Vue from 'vue'
import Router from 'vue-router'

//import { trailingSlash } from '@/util/helpers'
import {
  layout,
  route,
} from '@/util/routes'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash }
    if (savedPosition) return savedPosition

    return { x: 0, y: 0 }
  },
  routes: [
    layout('Default', [
      route('Dashboard'),
      route('Login',null,'login'),
      route('Student Profile',null,'studentprofile'),
      route('Professor Profile',null,'professorprofile'),
      route('Change Password',null,'changepassword'),
      route('Timetable',null,'timetable'),
      route('Test performance',null,'testperformance'),
      route('Student Performance',null,'studentperformance'),
      route('Contact Us',null,'contactus'),
      route('Coming Soon',null,'commingsoon'),
      route('Attendance Details',null,'attendancedetails'),
      route('Fee Details',null,'feedetails'),
      route('Due Pay',null,'DuePay'),
      route('DuePay New',null,'DuePayNew'),
      route('Payment Details',null,'paymentdetails'),
      route('Communication Log',null,'communicationlog'),
      route('Test Paper',null,'testpaper'),
      route('Study Material',null,'studymaterial'),
      route('Other Links',null,'otherlinks'),
      route('Payment Status',null,'paymentstatus/:txnid?'),
      route('Pay Now',null,'paynow/:txnid'),
      route('DuePayLive',null,'duepaylive'),
    ]),
  ],
})

router.beforeEach((to, from, next) => {
  const user = (localStorage.getItem("user")?true:false);
  // The old failed/canceled pages were removed; old links show the matching message on the status page.
  if (to.path.startsWith('/failedpayment') || to.path === '/canceledpayment')
  {
    next({ path: '/paymentstatus', query: { result: to.path.startsWith('/failedpayment') ? 'Failed' : 'Canceled' } });
    return;
  }
  // Pay site pages are opened from a signed link, without a login.
  const isPayPage = to.path.startsWith('/paynow/') ||
    (to.path.startsWith('/paymentstatus') && (to.query.sig || !to.params.txnid));
  if (isPayPage)
  {
    next();
    return;
  }
  if (to.path != '/login')
  {
    if (user) {
      next();
      return;
    }
    window.location="/login";
  }
  else
  {
    if (!user) {
      next();
      return;
    }
    next("/");
  }
  
})
export default router
